import { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { cn } from '@/lib/utils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Section 18 — CMS-managed FAQs (cms_faqs, assignedPage "foresee"). Hidden
// entirely if none are published — never invented content.
export const ForeseeFaq = () => {
  const [faqs, setFaqs] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/public/faqs?page=foresee`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(res.status))))
      .then((data) => alive && setFaqs(data.faqs || []))
      .catch(() => alive && setFaqs([]));
    return () => { alive = false; };
  }, []);

  if (!faqs || faqs.length === 0) return null;

  return (
    <section aria-labelledby="foresee-faq-heading" data-testid="foresee-faq" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <SectionHeader
          index="18"
          eyebrow="Questions"
          title="Frequently asked questions"
          testid="foresee-faq-header"
        />
        <div className="mt-10 divide-y divide-slate-200 rounded-xl border border-slate-200 bg-white">
          {faqs.map((faq, i) => {
            const isOpen = open === faq.faqId;
            return (
              <div key={faq.faqId}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={`foresee-faq-panel-${faq.faqId}`}
                  data-testid={`foresee-faq-q-${i + 1}`}
                  onClick={() => setOpen(isOpen ? null : faq.faqId)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-navy-900"
                >
                  <span className="text-base font-bold text-navy-900">{faq.question}</span>
                  <ChevronDown className={cn('h-4 w-4 shrink-0 text-slate-400 transition-transform duration-300', isOpen && 'rotate-180 text-navy-900')} aria-hidden="true" />
                </button>
                {isOpen && (
                  <div id={`foresee-faq-panel-${faq.faqId}`} className="px-6 pb-6" data-testid={`foresee-faq-a-${i + 1}`}>
                    <p className="text-sm leading-relaxed text-slate-600 sm:text-base">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
